
import Table from "@/common/elements/Table";
import { StyledReportContainer, StyledReportContent } from "./styles";
import CommonReportActionHeader from "./CommonReportActionHeader";

const CommonReport = ({children, 
  hideDefaultTable=false, 
  tableData = [], 
  onRowClickFn = () => {},
  reportHeader,
  tableInfoFooter,
  tableInfoHeader,
  hideInfoTableHeader
 }) => {

    const rowClickHandler = (data) =>{
       
       if(data && !hideDefaultTable){
        onRowClickFn(data)
       }
    }


    const printReportContent = () => {
      const reportContent = document.querySelector(".report-content");
    
      if (!reportContent) {
        console.warn("No element found with class 'report-content'");
        return;
      }
    
      const printWindow = window.open("", "", "width=800,height=600");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              h2 { font-size: 18px; }
              p { font-size: 14px; }
            </style>
          </head>
          <body>
            ${reportContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
    
    
    

    return(
      <>
        <StyledReportContainer className="report-container">

        <StyledReportContent className="report-content">
        { !hideDefaultTable &&
        <>
        {reportHeader && reportHeader}
        {tableInfoHeader || (!hideInfoTableHeader && (
          <div className="table-total-row">
            Total Number of Rows: {tableData?.data?.length}
          </div>
        ))}
        
        <Table 
        headers={tableData?.headers}
        data={tableData?.data}
        onRowClick={rowClickHandler}
        variant="outlined"
        />
        {tableInfoFooter && tableInfoFooter}
        </>
        }

        {children && (
            <>
            {children}
            </>
        )}
        </StyledReportContent>

        </StyledReportContainer>

       

        </>
    )
}
export default CommonReport;